<template>
  <!-- <div class="shop">订单详情</div> -->

  <div class="shop" v-loading="loading">
    <span class="title">订单基本信息</span>

    <el-button
      type="primary"
      size="mini"
      @click="closeOrder"
      v-show="orderMsg.order_status == 0"
      >关闭订单</el-button
    >

    <el-table
      :data="orderDetail"
      style="width:100%"
      max-height="600"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="订单编号" prop="order_sn"></el-table-column>
      <el-table-column label="用户账号" prop="user_mobile"></el-table-column>
      <el-table-column label="创建时间" prop="create_order_time">
      </el-table-column>
      <el-table-column label="订单原价">
        <template slot-scope="scope"
          >¥{{ scope.row.original_price }}</template
        >
      </el-table-column>
      <el-table-column
        label="订单状态"
        prop="order_status_name"
      ></el-table-column>
    </el-table>

    <span class="title">订单商品信息</span>
    <el-table
      :data="orderDetail"
      style="width:100%"
      max-height="600"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="商品图片">
        <template slot-scope="scope">
          <img
            style="width:100px;"
            :src="scope.row.goods_image ? scope.row.goods_image : errorImg"
            alt
          />
        </template>
      </el-table-column>
      <el-table-column label="商品名称" prop="goods_name"></el-table-column>
      <el-table-column label="商品售价" prop="original_price"></el-table-column>
      <el-table-column
        label="红包抵扣"
        prop="red_packet_price"
      ></el-table-column>
    </el-table>

    <span class="title">商家信息</span>
    <el-table
      :data="orderDetail"
      style="width:100%"
      max-height="600"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="商家账号" prop="store_mobile"></el-table-column>
      <el-table-column label="店铺地址" prop="shop_address"></el-table-column>
    </el-table>

    <!--关闭订单备注-->
    <jdialog
      title="关闭订单备注"
      :visible.sync="isCloseOrderremark"
      width="640px"
    >
      <div class="remark">
        <p class="note">
          提示：关闭订单后，资金会原路返还给用户，请确认无误后操作
        </p>
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="操作选项：" prop="refund">
            <el-radio-group v-model="form.type">
              <el-radio label="0">允许退款</el-radio>
              <el-radio label="1">拒绝退款</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="确认退款金额：">
            <el-input
              size="mini"
              v-model="orderMsg.red_packet_price"
              type="number"
              style="width:120px;"
              readonly
            ></el-input>
          </el-form-item>

          <el-form-item label="操作备注：" prop="mark">
            <el-input
              size="mini"
              v-model="form.remarks"
              placeholder="请输入操作备注"
              type="textarea"
              row="4"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-info">
          <el-button size="mini" @click="isCloseOrderremark = false"
            >取消</el-button
          >
          <el-button size="mini" type="primary" @click="centerorderInfo"
            >确定</el-button
          >
        </div>
      </div>
    </jdialog>

    <!--查看物流信息-->
    <!--              :icon="activity.icon"
              :type="activity.type"-->
    <!-- <jdialog
      title="物流详情"
      :visible.sync="isShowWoodsDetailInfo"
      width="640px"
    >
      <div class="block">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in woodActivities"
            :key="index"
            :timestamp="activity.acceptTime"
          >
            {{ activity.remark }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </jdialog> -->
  </div>
</template>

<script>
import errorImg from '@/assets/images/error_img.png'
import { memberOrderDetail, closeMemberOrder } from '@/api/autarky'
export default {
  data() {
    return {
      orderMsg: '',
      orderDetail: [],
      errorImg,isCloseOrderremark: false,
      form: {
        order_id: '',
        type: '',
        remarks: ''
      },
      loading: true,
      rules: {
        type: [
          { required: true, message: '请选择操作选项', trigger: 'change' }
        ],
      },
    }
  },
  created() {
    let orderId = this.$route.query.orderId
    //获取订单详情数据
    this.orderId = orderId
    //获取订单详情数据
    if (orderId) {
      this.getorderDetailGetData()
    }
  },
  mounted() {},
  methods: {
    
    //获取订单详情数据
    async getorderDetailGetData() {
      let res = await memberOrderDetail(this.orderId)
      if (res.code === 10000) {
        this.orderMsg = res.data
        this.orderDetail.push(res.data)
        this.loading = false
      } else {
        this.$message.error(res.message)
        this.loading = false
      }
    },

    // //关闭订单
    closeOrder() {
      this.form.order_id = this.orderDetail[0].order_id
      this.isCloseOrderremark = true
    },

    centerorderInfo() {
      if (!this.form.type) {
        this.$message.error('请选择是否允许退款')
        return
      }
      this.getcloseOrderUpdateData()
    },

    // //关闭订单
    async getcloseOrderUpdateData() {
      let res = await closeMemberOrder(this.form)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.orderDetail = []
        this.getorderDetailGetData()
        ;(this.form = {
          order_id: '',
          status: '',
          price: '',
          mark: ''
        }),
          (this.isCloseOrderremark = false)
      } else {
        this.$message.error(res.message)
      }
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;

  .title {
    color: #333333;
    font-size: 18px;
    margin-right: 12px;
    margin-top: 4px;
  }
  .status {
    color: #f4222d;
  }
  .loginfor {
    cursor: pointer;
  }
  .infotable {
    margin: 20px 0;
  }

  .remark {
    padding: 20px;
    .note {
      color: #666666;
      margin-bottom: 12px;
      text-align: center;
    }
    .btn-info {
      text-align: center;
    }
  }
  .block {
    padding: 20px;
  }
}
</style>
